
const domains = {
  prod: 'https://new.fleetsoft.pro',
  'sprint': 'https://dev.sprint.fleetjourney.com',
  'flux': 'https://dev.flux.fleetjourney.com',
  'cipher': 'https://dev.cipher.fleetjourney.com',
  'worker': 'https://dev.worker.fleetjourney.com',
  'kernel': 'https://dev.kernel.fleetjourney.com',
}

const active = 'sprint'

export default function (url) {
  let options = getOption()
  return  options + '/api' + url
}

export function getOption() {
  const isLocalhost = isLocalhost8080()
  if (isLocalhost){
    return domains[active]
  }
  
  return window.location.origin
}


function isLocalhost8080() {
  const { hostname } = window.location
  return hostname === 'localhost' || hostname === '127.0.0.1'
}
